/**
 * Location Storage Utility
 * Manages deducted location data with 5-minute expiration
 */

const LOCATION_STORAGE_KEY = 'deducted_location';
const LOCATION_EXPIRY_TIME = 12 * 60 * 60 * 1000; // 12 hours in milliseconds

/**
 * Save deducted location to localStorage with timestamp
 */
export const saveDeductedLocation = (locationData) => {
  const storageData = {
    ...locationData,
    timestamp: Date.now(),
  };
  localStorage.setItem(LOCATION_STORAGE_KEY, JSON.stringify(storageData));
};

/**
 * Get deducted location if it hasn't expired
 * Returns null if expired or not found
 */
export const getDeductedLocation = () => {
  try {
    const stored = localStorage.getItem(LOCATION_STORAGE_KEY);
    if (!stored) return null;

    const data = JSON.parse(stored);
    const now = Date.now();
    const isExpired = now - data.timestamp > LOCATION_EXPIRY_TIME;

    if (isExpired) {
      clearDeductedLocation();
      return null;
    }

    return data;
  } catch (error) {
    console.error('Error reading deducted location:', error);
    return null;
  }
};

/**
 * Clear deducted location from storage
 */
export const clearDeductedLocation = () => {
  localStorage.removeItem(LOCATION_STORAGE_KEY);
};

/**
 * Check if location is still valid (not expired)
 */
export const isLocationValid = () => {
  const location = getDeductedLocation();
  return location !== null;
};

/**
 * Get time remaining for location expiry (in seconds)
 */
export const getLocationTimeRemaining = () => {
  try {
    const stored = localStorage.getItem(LOCATION_STORAGE_KEY);
    if (!stored) return 0;

    const data = JSON.parse(stored);
    const now = Date.now();
    const elapsed = now - data.timestamp;
    const remaining = Math.max(0, LOCATION_EXPIRY_TIME - elapsed);

    return Math.ceil(remaining / 1000); // Return in seconds
  } catch (error) {
    console.error('Error calculating remaining time:', error);
    return 0;
  }
};
